<template>
  <div class="over_layout coming_sun"></div>
</template>
<script>
export default {
  mounted() {
    this.$parent.getData().then(changed => {
      if (changed) {
      }
    });
  },
}
</script>



// WEBPACK FOOTER //
// resources/js/components/pages/ComingSun.vue